import { Tooltip } from '@chakra-ui/react';
import { useState } from 'react';
import { GetColumnInput, IColumn } from '../types';
import { defaultHeaderRenderer } from '../headers';
import { hasPerm, P } from '../../../../../utilities/roles/permissions';
import { UserRole } from '../../../../../store/auth/types';
import { CellEventsHandler } from '../formatters';
import { CellProps } from '../../types';
import { OverflowedText } from '../../../../../utilities/overflowedText';

const AgentFormatter = (cellProps: CellProps, role: UserRole) => {
  const agencyName: string = cellProps.row.agentName ?? 'Agent Account Inactive';
  const isVisaSupport = !!cellProps.row.visaSupport;

  let hasAgents = false;
  let agentVal = '';

  const [isTooltipVisible, setIsTooltipVisible] = useState<boolean>(false);

  if (isVisaSupport) {
    if (role === UserRole.Enroly || role === UserRole.Admin) {
      agentVal = 'Enroly';
    } else {
      agentVal = 'Yes';
    }
    hasAgents = true;
  } else if (cellProps.row.agentName && cellProps.row.agentName !== '<Removed>') {
    agentVal = 'Yes';
    hasAgents = true;
  } else {
    agentVal = 'No';
  }

  if (hasAgents) {
    return (
      <CellEventsHandler cellProps={cellProps}>
        <Tooltip
          isDisabled={!isTooltipVisible}
          hasArrow
          placement="top"
          label={agentVal === 'Enroly' || isVisaSupport ? 'Visa support opt in' : agencyName}
        >
          <div>
            {agentVal}

            <OverflowedText
              overflowedHandler={setIsTooltipVisible}
              theme={{
                color: 'var(--ds-colors-muted)',
                lines: 3,
                margin: '4px 0 -4px',
                fontSize: 12,
              }}
            >
              {agentVal === 'Enroly' || isVisaSupport ? 'Visa support opt in' : agencyName}
            </OverflowedText>
          </div>
        </Tooltip>
      </CellEventsHandler>
    );
  }
  return <CellEventsHandler cellProps={cellProps}>{agentVal}</CellEventsHandler>;
};

export const AgentColumn = ({ role }: GetColumnInput): IColumn => ({
  item: {
    key: 'masterAgents',
    name: 'Agent',
    headerRenderer: defaultHeaderRenderer,
    sortable: true,
    width: 'minmax(104px, .75fr)',
    events: {
      goToStudentDetail: true,
    },
    formatter: (cellProps: CellProps) => AgentFormatter(cellProps, role!),
  },
  visible: ({ role }) => hasPerm(role, P.AGENT_VIEW),
});
